export const routerEventInputThumbnail = `query RouterEventInputThumbnail($inputId: ID!) {
  routerEventInputThumbnail(inputId: $inputId) {
    success
    message
    dataJson
  }
}
`;

export const routerEventInputsThumbnail = `query RouterEventInputsThumbnail($inputIds: [ID!]!) {
  routerEventInputsThumbnail(inputIds: $inputIds) {
    success
    message
    dataJson
  }
}
`;

export const listMediaConnectNetworkInterfaces = `query ListMediaConnectNetworkInterfaces {
  listMediaConnectNetworkInterfaces {
    success
    message
    dataJson
  }
}
`;

export const listMediaConnectInputs = `query ListMediaConnectInputs {
  listMediaConnectInputs {
    success
    message
    dataJson
  }
}
`;

export const listMediaConnectOutputs = `query ListMediaConnectOutputs {
  listMediaConnectOutputs {
    success
    message
    dataJson
  }
}
`;

export const getMediaConnectInput = `query GetMediaConnectInput($inputId: ID!) {
  getMediaConnectInput(inputId: $inputId) {
    success
    message
    dataJson
  }
}
`;

export const getMediaConnectOutput = `query GetMediaConnectOutput($outputId: ID!) {
  getMediaConnectOutput(outputId: $outputId) {
    success
    message
    dataJson
  }
}
`;

export const routerEventInputTargetStatus = `query RouterEventInputTargetStatus($eventId: ID!) {
  routerEventInputTargetStatus(eventId: $eventId) {
    success
    message
    dataJson
  }
}
`;

export const routerEventInputsTargetStatus = `query RouterEventInputsTargetStatus($eventIds: [ID!]!) {
  routerEventInputsTargetStatus(eventIds: $eventIds) {
    success
    message
    dataJson
  }
}
`;

export const routerInputTargetStatus = `query RouterInputTargetStatus($inputId: ID!) {
  routerInputTargetStatus(inputId: $inputId) {
    success
    message
    dataJson
  }
}
`;

export const routerInputsTargetStatus = `query RouterInputsTargetStatus($inputIds: [ID!]!) {
  routerInputsTargetStatus(inputIds: $inputIds) {
    success
    message
    dataJson
  }
}
`;

export const routerInputsTargetInfo = `query RouterInputsTargetInfo($inputIds: [ID!]!) {
  routerInputsTargetInfo(inputIds: $inputIds) {
    success
    message
    dataJson
  }
}
`;

export const routerOutputTargetInfo = `query RouterOutputTargetInfo($outputId: ID!) {
  routerOutputTargetInfo(outputId: $outputId) {
    success
    message
    dataJson
  }
}
`;

export const routerOutputsTargetInfo = `query RouterOutputsTargetInfo($outputIds: [ID!]!) {
  routerOutputsTargetInfo(outputIds: $outputIds) {
    success
    message
    dataJson
  }
}
`;

